module.exports = __webpack_public_path__ + "static/media/beeldmerk Technasium (zonder tekst).5db5202e.png";